import {
  Action,
  ActionType,
  IChangeStressResponse,
} from "models/stressCheck/changeStress";

import createReducer from "redux/createReducer";

export interface ChangeStressReducerType {
  loading: boolean;
  error?: any;
  changeStressResponse?: IChangeStressResponse;
}

const defaultState: ChangeStressReducerType = {
  loading: false,
  error: null,
  changeStressResponse: undefined,
};

export const changeStressReducer = createReducer<ChangeStressReducerType>(
  defaultState,
  {
    [ActionType.CHANGE_STRESS](state: ChangeStressReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CHANGE_STRESS_ERROR](
      state: ChangeStressReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CHANGE_STRESS_SUCCESS](
      state: ChangeStressReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        changeStressResponse: action.payload,
      };
    },

    [ActionType.CHANGE_STRESS_RESET](state: ChangeStressReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        changeStressResponse: undefined,
      };
    },
  }
);
